import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.tsx';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { DialogProvider } from "./contexts/DialogContext";
import Toasts from "./utils/toasts/Toasts.tsx";
import DialogHost from "./utils/dialog/DialogHost.tsx";
import { LoadingProvider } from "./contexts/LoadingContext";
import { CookieConsentProvider } from "./contexts/CookieConsentContext";

ReactDOM.render(
    <BrowserRouter>
        <CookieConsentProvider>
            <NotificationProvider>
                <DialogProvider>
                    <AuthProvider>
                        <LoadingProvider>
                            <App />
                            <Toasts />
                            <DialogHost />
                        </LoadingProvider>
                    </AuthProvider>
                </DialogProvider>
            </NotificationProvider>
        </CookieConsentProvider>
    </BrowserRouter>,
    document.getElementById('root')
);
